import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { HashLink as Link } from "react-router-hash-link";

export default function Header() {
  const [navbarOpen, setNavbarOpen] = React.useState(false);

  const menuItems = [
    {
      label: "Главная",
      href: "home"
    },
    {
      label: "Преимущества",
      href: "advantage"
    },
    {
      label: "Тарифы",
      href: "prices"
    },
    {
      label: "Частые вопросы",
      href: "support"
    },
    {
      label: "О нас",
      href: "about-us"
    },
    {
      label: "Контакты",
      href: "contact-us"
    }
  ]

  return (
    <nav className="flex flex-wrap items-center justify-between py-3 fixed bg-white w-full z-10">
      <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
        <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
          <div className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase flex items-center gap-2">
            <img src="/images/logo.png" alt="logo" className="w-10 h-10" />
            <span>HajjTravel.kz</span>
          </div>
          <button
            className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}>
            <GiHamburgerMenu />
          </button>
        </div>
        <div
          className={
            "lg:flex lg:flex-col flex-grow items-center" +
            (navbarOpen ? " flex" : " hidden")
          }
          id="example-navbar-danger"
        >
          <div className="flex flex-row gap-2 justify-end ml-auto"> 
            <div className="text-xs uppercase font-bold leading-snughover:opacity-75 cursor-pointer text-green-500 mr-3">Бизнесу</div>
            {/* <div className="text-2xs uppercase font-bold leading-snughover:opacity-75 cursor-pointer">Клиентам</div> */}
          </div>
          <ul className="flex flex-col lg:flex-row list-none lg:ml-auto mt-0">
            {menuItems.map((item, index) => (
              <li className="nav-item" key={index}>
                <div onClick={() => {
                  // TODO: Smooth properly
                  const target = document.getElementById(item.href)

                  if (!target) {
                    window.location.href = '/'
                    return;
                  }

                  const offset = target.getBoundingClientRect().top + window.scrollY;
                  window.scrollTo({
                    top: offset - 80,
                    behavior: "smooth"
                  });
                }}
                  className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snughover:opacity-75 cursor-pointer"
                >
                  {item.label}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
